import { defineSlotRecipe } from '@chakra-ui/react';
import colors from '../colors';

function generateStripe(size = '1rem', color = 'rgba(255, 255, 255, 0.15)') {
  return {
    backgroundImage: `linear-gradient(
    45deg,
    ${color} 25%,
    transparent 25%,
    transparent 50%,
    ${color} 50%,
    ${color} 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: `${size} ${size}`,
  };
}

const Progress = defineSlotRecipe({
  slots: ['root', 'track', 'range'],
  base: {
    root: {
      '--slider-track-size': '8px',
    },
    // shows the current progress (variable width)
    range: {
      bg: 'podcastPurple500',
      borderRadius: '10px',
      transitionDuration: '0ms',
    },
    // track along which the range moves (always 100% width)
    track: {
      bg: 'podcastShade200',
      borderRadius: '10px',
      width: '100%',
      zIndex: '8',
    },
  },
  variants: {
    visual: {
      loading: {
        track: {
          borderRadius: '10px',
        },
        range: {
          ...generateStripe('1rem', 'rgba(0,0,0,0.1)'),
          bg: 'podcastShade300',
          borderRadius: '10px',
        },
      },
      turquoise: {
        range: {
          bg: 'podcastBlue600',
        },
      },
      purple: {},
      smoothTransition: {
        range: {
          transitionProperty: 'width, inline-size, transform',
          transitionDuration: '2000ms',
          transitionTimingFunction: 'ease-out',
        },
      },
      orange: {
        range: {
          bg: 'podcastOrange',
        },
      },
      grey: {
        range: {
          bg: 'podcastShade300',
        },
      },
      upload: {
        track: {
          maxWidth: '200px',
          '--slider-track-size': '10px',
        },
      },
      miniPlayer: {
        track: {
          background: 'white',
        },
      },
      disabled: {
        track: {
          background: colors.podcastShade100,
          opacity: '0.8',
        },
      },
      clipGenie: {
        track: {
          height: '12px',
        },
      },
      comparison: {
        track: {
          h: '36px',
          w: '100%',
          background: colors.podcastPurple,
          div: {
            bg: `${colors.podcastBlue} !important`,
            borderRadius: 'none',
          },
        },
      },
      statistics: {
        track: {
          h: '36px',
          w: '580px',
          borderRadius: '10px',
        },
      },
      micVolume: {
        range: {
          h: '24px',
        },
        track: {
          h: '24px',
          borderRadius: '10px',
        },
      },
      participantVolume: {
        range: {
          borderRadius: '2px',
          background: `repeating-linear-gradient(
            to right,
            ${colors.podcastBlue},
            ${colors.podcastBlue} 2px,
            ${colors.podcastBlue600} 2px,
            ${colors.podcastBlue600} 4px
          );
          `,
        },
        track: {
          border: `2px solid ${colors.white}`,
          borderRadius: '4px',
          background: colors.white,
          h: '16px',
          w: '24px',
        },
      },
      studioVolume: {
        range: {
          h: '22px',
        },
        track: {
          border: `1px solid ${colors.podcastShade300}`,
          borderRadius: '10px',
          background: colors.white,
          h: '24px',
          w: '48px',
        },
      },
      volumeDisabled: {
        range: {
          h: '22px',
        },
        track: {
          border: `1px solid ${colors.podcastShade300}`,
          background: colors.podcastShade100,
          h: '24px',
          w: '48px',
          opacity: '0.5',
        },
      },
    },
  },
});

export default Progress;
